import { useState } from "react";
import { avatarUrl } from "../../lib/api";

/* Circular avatar that prefers the real uploaded image when we have an
 * `avatarId`, and falls back to a gold-gradient initial otherwise.
 *
 * Perf design notes:
 *  - The image URL is content-addressed (avatar_id = GridFS ObjectId), so
 *    it's SAFE to let the browser + Service Worker cache it forever.
 *    A new upload produces a NEW avatar_id → new URL → fresh fetch.
 *  - We DO NOT append `?v=` cache-busters here — that defeats caching.
 *    Only the owner's "My Account" screen appends `?v=` right after an
 *    upload for immediate feedback; everyone else gets the stable URL.
 *  - `loading="lazy"` + `decoding="async"` so a long list of 50 avatars
 *    doesn't block first paint.
 *  - `onError` swap-to-initials guards against a deleted avatar file.
 */
export default function AvatarImg({ avatarId, name, size = 40, className = "" }) {
  const [failed, setFailed] = useState(false);
  const initial = (name || "؟").trim().charAt(0);
  const showImg = !!avatarId && !failed;

  return (
    <div
      className={`rounded-full overflow-hidden bg-gradient-to-br from-[#F0C97E] via-[#D4AF37] to-[#8C6A18] text-white font-bold flex items-center justify-center shrink-0 shadow-[0_3px_10px_rgba(184,134,11,0.35)] border border-white/25 ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.42 }}
      aria-hidden="true"
    >
      {showImg ? (
        <img
          src={avatarUrl(avatarId)}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        initial
      )}
    </div>
  );
}
